import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import * as token from "@universityofmaryland/web-token-library";
import { createCompositeQuoteImage } from "./elements/image.js";
import { createCompositeQuoteText } from "./elements/text.js";
import "@universityofmaryland/web-icons-library/brand";
import { SMALL } from "./_constants.js";
import "@universityofmaryland/web-styles-library/layout";
import "@universityofmaryland/web-styles-library/typography";
import "@universityofmaryland/web-utilities-library/theme";
import { quoteAnimation } from "./helper/animation.js";
const CreateQuoteInlineElement = (props) => {
  const { isSizeLarge, image, isTypeFeatured = false } = props;
  const textContainer = createCompositeQuoteText(props);
  const imageContainer = image ? createCompositeQuoteImage({
    ...props,
    isTypeFeatured,
    image
  }) : null;
  const wrapper = new ElementBuilder().withClassName("quote-inline-container-wrapper").withStyles({
    element: {
      [`@container (min-width: ${SMALL}px)`]: {
        display: "flex",
        gap: token.spacing.lg,
        ...isSizeLarge && { gap: token.spacing.xl }
      }
    }
  });
  if (imageContainer) {
    wrapper.withChild(imageContainer);
  }
  wrapper.withChild(textContainer);
  const wrapperBuilt = wrapper.build();
  const container = new ElementBuilder().withClassName("quote-inline-container").withChild(wrapperBuilt).withStyles({
    element: {
      containerType: "inline-size",
      width: "100%"
    }
  }).build();
  const loadAnimation = () => {
    quoteAnimation({
      ...props,
      quoteElement: wrapperBuilt
    });
  };
  return {
    ...container,
    events: {
      loadAnimation
    }
  };
};
const createCompositeQuoteInline = CreateQuoteInlineElement;
export {
  createCompositeQuoteInline
};
//# sourceMappingURL=inline.js.map
